module.exports = __webpack_public_path__ + "static/fisherman-one-fish-26761c8b352fc016ec7e787b0d8619cd.png";